<template>
    <el-card v-loading="loading">
      <div slot="header">
        <el-alert
          title="Please Note: this change applies to all locations"
          type="warning"
          :closable="false"
          >
        </el-alert>
      </div>
      <el-form label-width="250px">
        <el-form-item label="Ach Return Fee">
          <el-input-number
            v-model="achReturnFee"
            :precision="2"
            :min="0"
            @change="enableSaveButton"
          >
          </el-input-number>
          <el-button :disabled="!editForm" @click="saveAchValue">
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </template>

<script>
import axios from 'axios';
import { ORG_API, ORG_API_ACHFEE } from '../env';

export default {
  name: 'FacilityAchReturnFee',
  props: { facility: { type: String, required: true } },
  async mounted() {
    await this.getFacilityAchFee();
  },
  watch: {
    async facility() {
      await this.getFacilityAchFee();
    },
  },
  data() {
    return {
      loading: true,
      achReturnFee: 0,
      editForm: false,
    };
  },
  methods: {
    enableSaveButton() {
      this.editForm = true;
    },
    async saveAchValue() {
      try {
        if (this.achReturnFee === 0) {
          this.$message.error({
            title: 'Validation Error',
            message: 'Amount should be greater than 0.',
          });
        }

        this.loading = true;
        await axios.put(`${ORG_API_ACHFEE}`, {
          achReturnFee: this.achReturnFee,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await this.getFacilityAchFee();
        this.loading = false;
        this.$message.success({
          title: 'Success',
          message: 'Successfully updated Ach Return Fee.',
        });
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async getFacilityAchFee() {
      this.loading = true;
      const response = await axios.get(`${ORG_API}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.achReturnFee = response.data.achReturnFee;
      if (!this.achReturnFee) {
        this.achReturnFee = 0;
      }
      this.loading = false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/FacilityAchReturnFee.vue